import "src/decidim/secure_elections/election_status";
require.context("../images", true);
import "entrypoints/decidim_secure_elections.scss";
